import { FC, PropsWithChildren, useState } from 'react';
import { ModalPropsWithoutClose, ModalType, OpenedModal } from '../types';
import { ModalsContext } from './ModalsContext';

export const ModalsProvider: FC<PropsWithChildren> = ({ children }) => {
  const [openedModals, setOpenedModals] = useState<OpenedModal[]>([]);

  const closeModal = (modalType: ModalType) => {
    setOpenedModals((previousModals) =>
      [...previousModals].filter((openedModal) => openedModal.modalType !== modalType),
    );
  };

  const openModal = (modalType: ModalType, modalProps?: ModalPropsWithoutClose) => {
    if (!openedModals.find((modal) => modal.modalType === modalType))
      setOpenedModals((previousModals) => [...previousModals, { modalType, modalProps }]);
  };

  const contextState = {
    closeModal,
    openedModals,
    openModal,
  };

  return <ModalsContext.Provider value={contextState}>{children}</ModalsContext.Provider>;
};
